const runTimeVars = {
  disableCarIdValidation:
    process.env.NODE_ENV === "development"
      ? "false"
      : "RUNTIME_VARIABLE_DISABLE_CAR_ID_VALIDATION",
  disabledPages:
    process.env.NODE_ENV === "development"
      ? ""
      : "RUNTIME_VARIABLE_DISABLED_PAGES",
  virtualLoopsServiceAddress:
    process.env.NODE_ENV === "development"
      ? "localhost:8000"
      : "RUNTIME_VARIABLE_VIRTUAL_LOOPS_SERVICE_ADDRESS",
  environmentName:
    process.env.NODE_ENV === "development"
      ? "undefined"
      : "RUNTIME_VARIABLE_ENVIRONMENT_NAME",
  enableMsalAuth:
    process.env.NODE_ENV === "development"
      ? String(process.env.REACT_APP_ENABLE_MSAL_AUTH) ?? "true"
      : "RUNTIME_VARIABLE_ENABLE_MSAL_AUTH",
  noAuthRole:
    process.env.NODE_ENV === "development"
      ? String(process.env.REACT_APP_NO_AUTH_ROLE) ?? "BasicUser"
      : "RUNTIME_VARIABLE_NO_AUTH_ROLE",
};

export default runTimeVars;
